import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { APISetting } from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import { gsap } from "gsap";

import { EventsManager, ReelsEvents, WinEvents } from "../../../abstracts/events/EventsManager";
import {
    AbstractFlowPresentation,
    setIsReelsLandingSkipped,
} from "../../../abstracts/flow/AbstractFlowStatePresentation";
import { AbstractGameMode } from "../../../abstracts/flow/AbstractGameMode";
import { addSkip } from "../../../abstracts/utils/JSUtils";
import { DDD } from "../../DDD";
import { normalConfig } from "../../config/DDDConfig";
import DDDReel from "../../modules/Reels/DDDReel";
import { DDDReelsView } from "../../modules/Reels/DDDReelsView";
// import { DDDBigFishSymbol } from "../../modules/Reels/symbols/DDDBigFishSymbol";
import { DDDWinView } from "../../modules/Winnings/DDDWinView";
import { DDDResultHandler } from "../decorators/DDDResultHandler";

export class DDDNormalResultPresentation extends AbstractFlowPresentation {
    private reelsView: DDDReelsView;
    private winView: DDDWinView;
    private reels: DDDReel[] = [];

    // private previousOpenedReels: string = ``;

    constructor(id: string = `DDDNormalResultPresentation`) {
        super(id);
    }

    protected handleEvents(): void {
        super.handleEvents();

        EventsManager.on(ReelsEvents.GET_REELS, (normalReels: DDDReel[]) => {
            this.reels = normalReels;
        });

        EventsManager.on(ReelsEvents.GET_REELS_VIEW, (view: DDDReelsView) => {
            this.reelsView = view;
        });

        EventsManager.on(WinEvents.GET_WINNINGS_VIEW, (view: DDDWinView) => {
            this.winView = view;
        });
    }

    protected onDefaultStart() {
        super.onDefaultStart();

        const padding = DDD.gameFlowController.calculatePaddingDuration(
            this.flowPresentationTimeline.totalDuration()
        );

        if (padding > 0) {
            gsap.delayedCall(padding, this.handleFinishAnimation.bind(this));
        } else {
            this.handleFinishAnimation();
        }
    }

    private handleFinishAnimation(): void {
        this.flowPresentationTimeline = gsap.timeline({});

        ////////////////////////

        const stopDelay = DDD.apiPlugin.settings.get(APISetting.FAST_SPIN, false)
            ? normalConfig.skipReelsDelay
            : normalConfig.stopSpinReelDelay;

        DDDResultHandler({
            gameReels: this.reels,
            timeline: this.flowPresentationTimeline,
            stopSpinDelay: stopDelay,
            onDecoratorComplete: this.handleFeatures.bind(this),
            reelsContainer: this.reelsView,
        });

        if (SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            this.skip();
        }
    }

    protected handleFeatures() {
        this.initializeTimeline(() => {
            gsap.delayedCall(0.01, () => {
                this.finishPresentation();
            });
        });

        this.reels.forEach((reel, reelIndex) => {
            if (DDD.model.xNudgeMap[reelIndex]) {
                this.flowPresentationTimeline.add(this.getXNudgeRevealAnimation(reelIndex));
                this.flowPresentationTimeline.addLabel(
                    `xNudgeEndLabel_` + reelIndex.toString(),
                    `>-0.1`
                );
            }
        });

        //! AICI DE FACUT SKIPUL DE A ZIS LARS DACA E NO WIN LA NUDGE
        /*
        if (this.specialSymbols.length > 0 && this.model.gameData.totalSpinWinnings === 0) {
            const stopSpecialSymbolsIdleAnimations = () => {
                this.specialSymbols.forEach((symbol) => {
                    if (symbol instanceof ApocalypseWildSymbol) {
                        symbol.getStaticAnimation();
                    } else {
                        symbol.getStaticAnimation();
                    }
                });
            };

            const stopIdleAnimationsLabel = `stopXNudgeIdleAnimationsLabel`;

            this.flowPresentationTimeline.addLabel(stopIdleAnimationsLabel, `>`);

            this.flowPresentationTimeline.call(
                () => {
                    stopSpecialSymbolsIdleAnimations();
                },
                undefined,
                stopIdleAnimationsLabel
            );

            this.flowPresentationTimeline.timeScale(2);
        }
        */

        // const tlDuration = this.flowPresentationTimeline.duration();
        // const tlTotalDuration = this.flowPresentationTimeline.totalDuration();
        // const tlTimeScale = this.flowPresentationTimeline.timeScale();
        //
        // console.log(`salam`);

        // const entries = Object.entries(this.flowPresentationTimeline.labels);
        //
        // const salam = entries.sort((a, b) => {
        //     return (
        //         this.flowPresentationTimeline.labels[a[0]] -
        //         this.flowPresentationTimeline.labels[b[0]]
        //     );
        // });
        //
        // console.log(salam);

        this.flowPresentationTimeline.resume();
    }

    private getXNudgeRevealAnimation(reelIndex: number): gsap.core.Timeline {
        const tl = gsap.timeline({
            smoothChildTiming: true,
            autoRemoveChildren: true,
            onStart: () => {
                addSkip(this.flowPresentationTimeline, this.controller);
                this.flowPresentationTimeline.timeScale(2);
            },
        });

        if (
            (this.model.gameData.mode === AbstractGameMode.FREESPIN ||
                this.model.gameData.mode === AbstractGameMode.SUPER_FREESPIN) &&
            this.model.gameData.freespinsLeft === 0
        ) {
            this.reels[reelIndex].isLocked = false;
        } else {
            this.reels[reelIndex].isLocked = this.model.gameData.stickyXNudge[reelIndex];
        }

        let hasMoreXNudges = false; // DDD.model.hasWildsToNudge && reelIndex < 2;
        for (let i = 0; i < DDD.model.xNudgeMap.length; i++) {
            if (i > reelIndex && DDD.model.xNudgeMap[i]) {
                hasMoreXNudges = true;
                break;
            }
        }

        tl.add(this.reels[reelIndex].getXNudgeAnimation(hasMoreXNudges));

        return tl;
    }

    protected skip(): void {
        super.skip();

        this.flowPresentationTimeline.timeScale(3);

        setIsReelsLandingSkipped(true);
    }
}
